//angular imports
import { computed, signal, WritableSignal } from "@angular/core";
import { ListItem } from "@app/shared";



export abstract class AbstractRoomModel {

  public id: string = "";
  public name: WritableSignal<string> = signal<string>(null);
  public thumbnailUrl: WritableSignal<string> = signal<string>(null);
  public isActive: WritableSignal<boolean> = signal<boolean>(false);
  public isChecked: WritableSignal<boolean> = signal<boolean>(false);
  public code: WritableSignal<string> = signal<string>(null);
  public subCode: WritableSignal<string> = signal<string>(null);
  public hasImageError: WritableSignal<boolean> = signal<boolean>(false);


  public fullCode = computed(() => {
    const code = this.code();
    const sub = this.subCode();
    return code ? (sub ? `${code}-${sub}` : code) : null;
  });

  public fullName = computed(() => {
    const code = this.fullCode();
    const name = this.name();
    return code ? `${code} - ${name}` : name;
  });

  public select = (val: boolean): void => {
    this.isChecked.set(val);
  };

  public abstract toListItem$?(selected: WritableSignal<boolean>): ListItem<any>;

  public handleImageError(): void {
    this.hasImageError.set(true);
  }
}